<template>
<div>
    <div v-if=" GET_ORDER_DETAIL_SIGNEDIN_RES!=null">
    <cBookingStatus :bookingStatus="page"></cBookingStatus>
    </div>
</div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
import { COMPONENT_NAME,PATHNAME,} from "../../../../util/constants";
import { addClassToBody,removeClassBody } from "../../../../util/util";
import apiGetOrderSignedIn from "../../../../services/apiGetOrderSignedIn.js";
import cBookingStatus from "../../../../components/confirmation/cBookingStatus";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import BaseConfiguration from "../../../../config/base";
import {handleJWT,getErrorAlertValue, handleSessionExist,} from "../../../../util/util";
import { ROUTER_PARAM, PAYMENT_PROCEED_TO, PROCEED_TO_TYPE} from "../../../../util/constants";
import router, { navigate, goBack } from "../../../../router/index";
export default {
    components: {
    cBookingStatus
  },
   data: () => ({
            page: 'HoldPage',
            alertValue:null,
        }), 
         computed: {
    
    ...mapGetters("sPaymentPage", {
      GET_CREATE_BOOKING_RES: "GET_CREATE_BOOKING_RES",
      GET_ORDER_DETAIL_RES: "GET_ORDER_DETAIL_RES",
       GET_ORDER_DETAIL_SIGNEDIN_RES: "GET_ORDER_DETAIL_SIGNEDIN_RES"
    })
  },
        methods:{
...mapActions("sResult", {
      SET_AIRLINES:"SET_AIRLINES",
      
    }),
    ...mapActions("sPaymentPage", {
      
      SET_ORDER_DETAIL_SIGNEDIN_RES:"SET_ORDER_DETAIL_SIGNEDIN_RES"
    }),
            /// getOrderDetail_signedIn api (to be called before navigating to success and hold page)
    async getOrderDetailsSignedIn(pOrderId,pOrderPayId) {
              let retValue;
              try {
                if(BaseConfiguration.isDebug) console.log("getOrderDetailsSignedIn");
                let orderDetReq = apiGetOrderSignedIn.buildRequest(pOrderId,pOrderPayId);

                if(orderDetReq){
                    let orderRes = await apiGetOrderSignedIn.getResponse(orderDetReq);

                     if (VALIDATE_SUCCESS_RES(orderRes)) {
                        retValue = orderRes.data;
                            if(retValue.data&&retValue.data.airlines){
                         this.SET_AIRLINES(retValue.data.airlines);
                        }
                        this.SET_ORDER_DETAIL_SIGNEDIN_RES(retValue);
                        // this.loggerFunc();
                     }
                       
                     else {
                        //if status error
                        retValue = orderRes.data;
                        
                        let error = getErrorMessage(orderRes);
          
                        let isJwt = handleJWT(error);
                        if (!isJwt) {
                            let isSessionExpired;
                            if(orderRes){
                              isSessionExpired = handleSessionExist(orderRes.data);
                            }
                         if(!isSessionExpired){
                            this.alertValue=getErrorAlertValue(error);
                         }
                     }
                  }

                }
          
              } catch (err) {
                      let body = Logger.buildRequest(
                        FILE_NAME.SUCCESSPAGE,
                        "error in getOrderDetailsSignedIn",
                        err.toString(),
                        "getOrderDetailsSignedIn",
                        LOG_TYPE.ERROR
                      );
                      Logger.getResponse(body);
                    }
                return retValue;
              }, 

   /// Logger the pnr and order id if there is no ticket numbers in response incase of success case
//   loggerFunc() {
    
//       try {
//         if(BaseConfiguration.isDebug) console.log("loggerFunc");
//         let body=[];
//         if(this.GET_ORDER_DETAIL_RES && this.GET_ORDER_DETAIL_RES.data.ticketNumbers && 
//          this.GET_ORDER_DETAIL_RES.data.ticketNumbers.length==0) {
//            body.push(this.GET_ORDER_DETAIL_RES.data.pnr.toString(),this.GET_ORDER_DETAIL_RES.data.orderID,"has no ticket number")
           
//            throw body;
//          }
//         else if(this.GET_ORDER_DETAIL_SIGNEDIN_RES && this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.ticketNumbers
//           && this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.ticketNumbers.length==0) {
//             body.push(this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.pnr.toString(),this.GET_ORDER_DETAIL_SIGNEDIN_RES.data.orderID,"has no ticket number")
           
//            throw body;
//          }
       
          

//       } catch (err) {
//                 let body = Logger.buildRequest(
//                   FILE_NAME.BOOKING_STATUS_PAGE,
//                   "has no ticket number",
//                   err.toString(),
//                   "loggerFunc",
//                   LOG_TYPE.ERROR
//                 );
//                 Logger.getResponse(body);
//               }
      
// },

        },

        mounted() {
           //this.$root.$emit("toggle-fixed-header", true);
           this.$root.$emit("toggle-sidebar-minimize");
        },

    async created(){
         this.$root.$emit("toggle-sidebar-minimize"); 
         if(this.GET_CREATE_BOOKING_RES!=null && this.GET_ORDER_DETAIL_RES==null){
          if(this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderId &&
              this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderPaymentId) {
              let orderSignedInRes =  await this.getOrderDetailsSignedIn(
                                this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderId,
                                this.GET_CREATE_BOOKING_RES.data.data.bookingStatus.orderPaymentId);
              }
              /// if there is no order id and order payment id, navigate to failed page
              else{
                body.push( "has no order id or order payment id in createbooking api response")
                     
                      
                      navigate(PATHNAME.FAILEDPAGE);
                      throw body;
                      
                      
              }
         }
    },
       beforeCreate() {    
   addClassToBody(COMPONENT_NAME.HOLDPAGE);
  },
  
   beforeDestroy() {
              this.$root.$emit("toggle-sidebar-minimize", true);

       removeClassBody();
    },
}
</script>


